/* eslint-disable no-param-reassign */
/* eslint-disable object-curly-newline */
/* eslint-env jquery */

import { Component, registerComponent } from 'js/component.js';

const componentName = 'repair-request-form';
class RepairRequestForm extends Component {
    elements = {
        container: this.element.querySelector(`.${componentName}__container`),
        form: this.element.querySelector(`.${componentName}__form`),
        emailInput: this.element.querySelector(`.${componentName}__text-inputs .ra-input__input[name="email"]`),
        companyInput: this.element.querySelector(`.${componentName}__text-inputs .ra-input__input[name="company"]`),
        firstNameInput: this.element.querySelector(`.${componentName}__text-inputs .ra-input__input[name="firstName"]`),
        lastNameInput: this.element.querySelector(`.${componentName}__text-inputs .ra-input__input[name="lastName"]`),
        catalogNumberInput: this.element.querySelector(`.${componentName}__text-inputs .ra-input__input[name="catalogNumber"]`),
        catalogNumberAutosuggest: this.element.querySelector(`.${componentName}__catalog-number-autosuggest-container`),
        serialNumberInput: this.element.querySelector(`.${componentName}__text-inputs .ra-input__input[name="serialNumber"]`),
        termsCheckbox: this.element.querySelector(`.${componentName}__terms-checkbox-container input`),
        termsTextContainer: this.element.querySelector(`.${componentName}__terms-text`),
        fileInput: this.element.querySelector(`.${componentName}__insurance-upload-input`),
        fileNameTextContainer: this.element.querySelector(`.${componentName}__insurance-upload-file-name-text-container`),
        fileNameText: this.element.querySelector(`.${componentName}__insurance-upload-file-name-text`),
        fileSelectedText: this.element.querySelector(`.${componentName}__insurance-upload-file-selected-text`),
        fileSizeExceededText: this.element.querySelector(`.${componentName}__insurance-upload-size-exceeded-text`),
        textInputs: this.element.querySelectorAll(`.${componentName}__text-inputs .ra-input__input`),
        detailsTextarea: this.element.querySelector(`.${componentName}__text-inputs .ra-input__input[name="requestDetails"]`),
        submitButton: this.element.querySelector(`.${componentName}__submit-button`),
        successMessageContainer: this.element.querySelector(`.${componentName}__success-message-container`),
        signedOutContainer: this.element.querySelector(`.${componentName}__signed-out-container`),
        signInLink: this.element.querySelector(`.${componentName}__signed-out-button`),
    };

    constants = {
        theme: this.elements.container.dataset.theme,
        catalogNumber: null,
        path: '/bin/right-to-repair',
        countryCode: document.documentElement.lang?.split('-')[1]?.toLowerCase() || 'us',
        autosuggestDebounceTime: 300,
    };

    state = {
        autosuggestDebounceTimer: null,
        catalogNumberValid: false,
    };

    handleValidation = (showErrorState = true) => {
        let hasError = false;
        const requiredFields = this.element.querySelectorAll('input[data-required], textarea[data-required], select[data-required]');

        [...requiredFields].forEach((fieldEle) => {
            if (fieldEle.disabled || fieldEle.closest(`.${this.constants.theme}-formfield`).classList.contains('hidden')) {
                return;
            }
            const isText = fieldEle.classList.contains(`${this.constants.theme}-input__input`);
            const isCheckbox = fieldEle.classList.contains(`${this.constants.theme}-checkbox__checkbox`);
            const isSelect = fieldEle.classList.contains(`${this.constants.theme}-select__select`);

            // Text Fields
            if (isText) {
                const inputValue = fieldEle.value;
                const isEmpty = inputValue === '';
                const parentContainerEle = fieldEle.closest(`.${this.constants.theme}-formfield`);
                const errorMessage = parentContainerEle.querySelector(`.${this.constants.theme}-formfield__caption-error`);

                if (isEmpty) {
                    hasError = true;
                    if (showErrorState) {
                        parentContainerEle.classList.add(`${this.constants.theme}-formfield--invalid`);
                        fieldEle.classList.add(`${this.constants.theme}-input__input--invalid`);
                        if (errorMessage) {
                            errorMessage.setAttribute('aria-hidden', 'false');
                        }
                    }
                } else {
                    parentContainerEle.classList.remove(`${this.constants.theme}-formfield--invalid`);
                    fieldEle.classList.remove(`${this.constants.theme}-input__input--invalid`);
                    if (errorMessage) {
                        errorMessage.setAttribute('aria-hidden', 'true');
                    }
                }
            }

            // Checkboxes
            if (isCheckbox) {
                const parentContainerEle = fieldEle.closest(`.${this.constants.theme}-formfield`);
                const errorMessage = parentContainerEle.querySelector(`.${this.constants.theme}-formfield__caption-error`);
                const inputEles = fieldEle.querySelectorAll('input');
                let isEmpty = true;

                [...inputEles].forEach((inputEle) => {
                    if (inputEle.checked === true) {
                        isEmpty = false;
                    }
                });

                if (isEmpty) {
                    hasError = true;
                    if (showErrorState) {
                        parentContainerEle.classList.add(`${this.constants.theme}-formfield--invalid`);
                        fieldEle.classList.add(`${this.constants.theme}-checkbox__checkbox--invalid`);
                        if (errorMessage) {
                            errorMessage.setAttribute('aria-hidden', 'false');
                        }
                    }
                } else {
                    parentContainerEle.classList.remove(`${this.constants.theme}-formfield--invalid`);
                    fieldEle.classList.remove(`${this.constants.theme}-checkbox__checkbox--invalid`);
                    if (errorMessage) {
                        errorMessage.setAttribute('aria-hidden', 'true');
                    }
                }
            }

            // Selects
            if (isSelect) {
                const isEmpty = fieldEle.value === '';
                const parentContainerEle = fieldEle.closest(`.${this.constants.theme}-formfield`);
                const errorMessage = parentContainerEle.querySelector(`.${this.constants.theme}-formfield__caption-error`);

                if (isEmpty) {
                    hasError = true;
                    if (showErrorState) {
                        parentContainerEle.classList.add(`${this.constants.theme}-formfield--invalid`);
                        fieldEle.classList.add(`${this.constants.theme}-select__select--invalid`);
                        if (errorMessage) {
                            errorMessage.setAttribute('aria-hidden', 'false');
                        }
                    }
                } else {
                    parentContainerEle.classList.remove(`${this.constants.theme}-formfield--invalid`);
                    fieldEle.classList.remove(`${this.constants.theme}-select__select--invalid`);
                    if (errorMessage) {
                        errorMessage.setAttribute('aria-hidden', 'true');
                    }
                }
            }
        });

        return hasError;
    };

    handleFileInputChange = (event) => {
        const file = event.target.files[0];
        if (!file) {
            this.elements.fileNameText.textContent = '';
            this.elements.fileNameTextContainer.classList.add('empty');
            this.elements.fileSelectedText.classList.add('empty');
            this.elements.submitButton.disabled = !this.elements.termsCheckbox.checked || !event.target.value || this.handleValidation(false) || !this.state.catalogNumberValid;
            return;
        }
        if (file.size > 5 * 1024 * 1024) {
            this.elements.fileNameText.textContent = '';
            this.elements.fileNameTextContainer.classList.add('empty');
            this.elements.fileSelectedText.classList.add('empty');
            this.elements.fileSizeExceededText.classList.remove('hidden');
            this.elements.submitButton.disabled = true;
            event.target.value = '';
            return;
        }
        this.elements.fileNameText.textContent = file.name;
        this.elements.fileNameTextContainer.classList.remove('empty');
        this.elements.fileSelectedText.classList.remove('empty');
        this.elements.fileSizeExceededText.classList.add('hidden');
        this.elements.submitButton.disabled = !this.elements.termsCheckbox.checked || !event.target.value || !this.state.catalogNumberValid;
    };

    handleFileNameRemove = () => {
        this.elements.fileInput.value = '';
        this.elements.fileNameText.textContent = '';
        this.elements.fileNameTextContainer.classList.add('empty');
        this.elements.fileSelectedText.classList.add('empty');
        this.elements.submitButton.disabled = true;
    };

    handleTermsCheckboxChange = () => {
        this.elements.submitButton.disabled = !this.elements.termsCheckbox.checked || !this.elements.fileInput.value || this.handleValidation(false) || !this.state.catalogNumberValid;
    };

    handleSubmit = async (event) => {
        event.preventDefault();

        const hasError = this.handleValidation();
        if (hasError) {
            console.warn('Form has errors');
            return;
        }

        const formData = new FormData(this.elements.form);
        if (this.constants.catalogNumber) {
            formData.append('catalogNumber', this.constants.catalogNumber);
        }
        const response = await fetch(this.constants.path, {
            method: 'POST',
            body: formData,
        });

        const data = await response.text();

        this.elements.successMessageContainer.classList.remove('hidden');
        this.elements.form.classList.add('hidden');
    };

    handleTermsTextContainerScroll = () => {
        if (!this.elements.termsCheckbox || !this.elements.termsCheckbox.disabled) {
            this.elements.termsTextContainer.removeEventListener('scroll', this.handleTermsTextContainerScroll);
            return;
        }
        const scrollPosition = this.elements.termsTextContainer.scrollTop;
        const containerHeight = this.elements.termsTextContainer.clientHeight;
        const contentHeight = this.elements.termsTextContainer.scrollHeight;
        const isAtBottom = scrollPosition + containerHeight + 25 >= contentHeight;
        this.elements.termsCheckbox.disabled = !isAtBottom;
    };

    handleTextInputChange = () => {
        this.elements.submitButton.disabled = !this.elements.termsCheckbox.checked || !this.elements.fileInput.value || this.handleValidation(false) || !this.state.catalogNumberValid;
    };

    checkSignInStatus = () => {
        const queryParams = new URLSearchParams(window.location.search);
        let loggedInData;
        if (window['userData']) {
            loggedInData = window['userData'];
        } else if (localStorage.getItem('loggedInData')) {
            try {
                loggedInData = JSON.parse(localStorage.getItem('loggedInData'));
            } catch (e) {
                console.warn('Error parsing loggedInData from localStorage', e);
            }
        }
        if (loggedInData) {
            this.elements.emailInput.value = loggedInData?.email;
            this.elements.companyInput.value = loggedInData?.company;
            this.elements.firstNameInput.value = loggedInData?.firstName;
            this.elements.lastNameInput.value = loggedInData?.lastName;
            this.elements.serialNumberInput.value = queryParams.get('SN') || '';
            if (this.constants.catalogNumber) {
                this.elements.catalogNumberInput.value = this.constants.catalogNumber;
                this.elements.catalogNumberInput.disabled = true;
                this.elements.catalogNumberInput.classList.add(`${this.constants.theme}-input__input--disabled`);
                this.state.catalogNumberValid = true;
            } else if (queryParams.get('catalogNumber')) {
                this.elements.catalogNumberInput.value = queryParams.get('catalogNumber');
            }
            this.elements.form.classList.remove('hidden');
        } else {
            this.elements.signedOutContainer.classList.remove('hidden');
            this.elements.signInLink.addEventListener('click', () => {
                if (document.querySelector('.account-menu__sign-in')) {
                    document.querySelector('.account-menu__sign-in').click();
                } else {
                    if (localStorage.getItem('adfsLogin')) {
                        window.location.href = localStorage.getItem('adfsLogin');
                    }
                }
            });
        }
    };

    handleCatalogNumberInputChange = async () => {
        clearTimeout(this.state.autosuggestDebounceTimer);
        this.state.autosuggestDebounceTimer = setTimeout(() => {
            this.handleCatalogNumberInputChangeDebounced();
        }, this.constants.autosuggestDebounceTime);
    };

    handleCatalogNumberInputChangeDebounced = async () => {
        const catalogNumber = this.elements.catalogNumberInput.value;
        const autosuggestList = this.elements.catalogNumberAutosuggest.querySelector(`.${componentName}__catalog-number-autosuggest-list`);
        try {
            const response = await fetch(`${this.constants.path}?catalogNumber=${catalogNumber}&locale=${this.constants.countryCode}`);
            const data = await response.json();
            if (!data.success) {
                console.warn('Error fetching catalog numbers', data.error);
                this.elements.catalogNumberAutosuggest.classList.add('hidden');
                return;
            }
            const dataArray = data.catalogNumbers;
            if (dataArray.length === 0) {
                this.elements.catalogNumberAutosuggest.classList.add('hidden');
                this.state.catalogNumberValid = false;
                return;
            }
            autosuggestList.querySelectorAll(`.${componentName}__catalog-number-autosuggest-item`).forEach((item) => {
                if (!dataArray.includes(item.getAttribute('data-catalog-number'))) {
                    item.remove();
                }
            });
            dataArray.forEach((item) => {
                if (autosuggestList.querySelector(`[data-catalog-number="${item}"]`)) {
                    return;
                }
                const autosuggestItem = document.createElement('div');
                autosuggestItem.classList.add(`${componentName}__catalog-number-autosuggest-item`);
                autosuggestItem.setAttribute('tabindex', '0');
                autosuggestItem.setAttribute('data-catalog-number', item);
                autosuggestItem.textContent = item;
                autosuggestItem.addEventListener('click', () => {
                    if (this.elements.catalogNumberInput.disabled) {
                        return;
                    }
                    this.elements.catalogNumberInput.value = item;
                    this.elements.catalogNumberAutosuggest.classList.add('hidden');
                    this.state.catalogNumberValid = true;
                    this.elements.submitButton.disabled = !this.elements.termsCheckbox.checked || !this.elements.fileInput.value || this.handleValidation(false);
                });
                autosuggestItem.addEventListener('keydown', (event) => {
                    if (event.key === 'Enter') {
                        if (this.elements.catalogNumberInput.disabled) {
                            return;
                        }
                        this.elements.catalogNumberInput.value = item;
                        this.elements.catalogNumberAutosuggest.classList.add('hidden');
                        this.state.catalogNumberValid = true;
                        this.elements.submitButton.disabled = !this.elements.termsCheckbox.checked || !this.elements.fileInput.value || this.handleValidation(false);
                    }
                });
                autosuggestItem.addEventListener('blur', async () => {
                    // If focus is no longer on the autosuggest list or input, hide the list
                    setTimeout(async () => {
                        if (!document.querySelector(`.${componentName}__catalog-number-autosuggest-item:focus`)
                                && !document.querySelector('input[name="catalogNumber"]:focus')) {
                            this.elements.catalogNumberAutosuggest.classList.add('hidden');

                            // If debounce timer is still running, wait for it to finish
                            if (this.state.autosuggestDebounceTimer) {
                                await new Promise(resolve => setTimeout(resolve, this.constants.autosuggestDebounceTime));
                            }
                            if (!this.state.catalogNumberValid) {
                                if (this.elements.catalogNumberInput.disabled) {
                                    return;
                                }
                                this.elements.catalogNumberInput.value = '';
                                this.elements.submitButton.disabled = true;
                            }
                        }
                    }, 50);
                });
                autosuggestList.appendChild(autosuggestItem);
            });
            this.elements.catalogNumberAutosuggest.classList.remove('hidden');
            this.state.catalogNumberValid = dataArray.includes(catalogNumber);
        } catch (error) {
            console.warn('Error handling catalog number input change', error);
            autosuggestList.innerHTML = '';
            this.elements.catalogNumberAutosuggest.classList.add('hidden');
        }
    };

    handleCatalogNumberInputBlur = async () => {
        // If focus is not on the autosuggest list, hide
        setTimeout(async () => {
            if (!document.querySelector(`.${componentName}__catalog-number-autosuggest-item:focus`)) {
                this.elements.catalogNumberAutosuggest.classList.add('hidden');

                // If debounce timer is still running, wait for it to finish
                if (this.state.autosuggestDebounceTimer) {
                    await new Promise(resolve => setTimeout(resolve, this.constants.autosuggestDebounceTime));
                }
                if (!this.state.catalogNumberValid) {
                    if (this.elements.catalogNumberInput.disabled) {
                        return;
                    }
                    this.elements.catalogNumberInput.value = '';
                    this.elements.submitButton.disabled = true;
                }
            }
        }, 50);
    };

    addEventListeners = () => {
        this.elements.form.addEventListener('submit', async (event) => {
            window.dispatchEvent(new CustomEvent('show-loading'));
            await this.handleSubmit(event);
            window.dispatchEvent(new CustomEvent('hide-loading'));
        });
        this.elements.fileInput.addEventListener('change', this.handleFileInputChange);
        this.elements.termsCheckbox.addEventListener('change', this.handleTermsCheckboxChange);
        this.elements.fileNameTextContainer.addEventListener('click', this.handleFileNameRemove);
        this.elements.textInputs.forEach((input) => {
            input.addEventListener('change', this.handleTextInputChange);
        });
        this.elements.catalogNumberInput.addEventListener('input', this.handleCatalogNumberInputChange);
        this.elements.catalogNumberInput.addEventListener('focus', this.handleCatalogNumberInputChange);
        this.elements.catalogNumberInput.addEventListener('blur', this.handleCatalogNumberInputBlur);
        document.addEventListener('click', async (event) => {
            if (!this.elements.catalogNumberInput.contains(event.target) && !this.elements.catalogNumberAutosuggest.contains(event.target)) {
                this.elements.catalogNumberAutosuggest.classList.add('hidden');

                // If debounce timer is still running, wait for it to finish
                if (this.state.autosuggestDebounceTimer) {
                    await new Promise(resolve => setTimeout(resolve, this.constants.autosuggestDebounceTime));
                }
                if (!this.state.catalogNumberValid) {
                    if (this.elements.catalogNumberInput.disabled) {
                        return;
                    }
                    this.elements.catalogNumberInput.value = '';
                    this.elements.submitButton.disabled = true;
                }
            }
        });

        this.elements.termsTextContainer.addEventListener('scroll', this.handleTermsTextContainerScroll);
        const termsResizeObserver = new ResizeObserver(() => {
            if (this.elements.termsCheckbox.disabled) {
                this.elements.termsCheckbox.disabled = (this.elements.termsTextContainer.scrollHeight > (this.elements.termsTextContainer.offsetHeight + 5));
            }
        });
        termsResizeObserver.observe(this.elements.termsTextContainer);
    };

    initDom = () => {
        if (this.elements.container.dataset.catalogNumber) {
            this.constants.catalogNumber = this.elements.container.dataset.catalogNumber;
        } else if (window.location.pathname.includes('/products/details.')) {
            this.constants.catalogNumber = window.location.pathname.split('/products/details.')[1].split('.')[0];
        }
        if (this.elements.detailsTextarea) {
            this.elements.detailsTextarea.setAttribute('placeholder', "Please describe the issue you're experiencing or provide details about your repair request.");
        }
        this.checkSignInStatus();
        this.elements.termsCheckbox.disabled = this.elements.termsTextContainer.scrollHeight > (this.elements.termsTextContainer.offsetHeight + 5);
    };

    /**
     * Initialize Component
     */
    init = () => {
        if (typeof getPiraObj === 'function' || window.location.hostname.includes('localhost')) {
            this.initDom();
            this.addEventListeners();
        } else {
            document.addEventListener('piraLoadedSynced', () => {
                this.initDom();
                this.addEventListeners();
            });
        }
    };
}

registerComponent(`.${componentName}`, RepairRequestForm);
